(function () {
  'use strict';
  if (window.VindemiloCharacterGallery) { window.VindemiloCharacterGallery.boot(document); return; }
  var initialized = new WeakSet();
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    var index = Number(root.dataset.defaultIndex || 0);
    var stage = root.querySelector('.vnd-character-gallery__stage');
    var dialog = root.querySelector('[data-gallery-dialog]');
    var images = [].slice.call(root.querySelectorAll('[data-gallery-image]'));
    var count = images.length;
    if (!count) return;
    var counter = root.querySelector('[data-gallery-counter]');
    var dialogImage = root.querySelector('[data-gallery-dialog-image]');
    var touch;
    var dialogThumbs = root.querySelector('.vnd-character-gallery__dialog-thumbs');
    var thumbsBuilt = false;
    function prepareDialog() {
      if (thumbsBuilt || !dialogThumbs) return;
      var fragment = document.createDocumentFragment();
      root.querySelectorAll('.vnd-character-gallery__rail [data-gallery-select]').forEach(function (source) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.gallerySelect = source.dataset.gallerySelect;
        button.setAttribute('aria-label', source.getAttribute('aria-label'));
        button.setAttribute('aria-pressed', 'false');
        var thumb = source.querySelector('img');
        if (thumb) button.appendChild(thumb.cloneNode(true));
        fragment.appendChild(button);
      });
      dialogThumbs.appendChild(fragment);
      thumbsBuilt = true;
    }
    function updateDialogImage() {
      if (!dialogImage || !dialog || !dialog.open) return;
      dialogImage.src = currentImage().href;
      dialogImage.alt = currentImage().querySelector('img').alt;
    }
    function currentImage() { return images[index]; }
    function setIndex(next, focusTarget) {
      index = (next + count) % count;
      images.forEach(function (image, imageIndex) {
        var active = imageIndex === index;
        var nextVisible = imageIndex === (index + 1) % count;
        image.hidden = !(active || nextVisible);
        image.classList.toggle('is-active', active);
        image.classList.toggle('is-next', nextVisible && !active);
      });
      root.querySelectorAll('[data-gallery-select]').forEach(function (select) {
        var active = Number(select.dataset.gallerySelect) === index;
        select.setAttribute('aria-pressed', String(active));
        select.classList.toggle('is-active', active);
      });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(images.length).padStart(2, '0');
      updateDialogImage();
      if (focusTarget) focusTarget.focus();
    }
    function move(delta, focusTarget) { setIndex(index + delta, focusTarget); }
    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-gallery-select]');
      if (target && root.contains(target)) {
        if (target.tagName === 'A') event.preventDefault();
        setIndex(Number(target.dataset.gallerySelect), target.closest('[data-gallery-dialog]') ? target : null);
        return;
      }
      target = event.target.closest('[data-gallery-prev]');
      if (target) { move(-1, target.closest('[data-gallery-dialog]') ? target : null); return; }
      target = event.target.closest('[data-gallery-next]');
      if (target) { move(1, target.closest('[data-gallery-dialog]') ? target : null); return; }
      if (event.target.closest('[data-gallery-close]')) { dialog.close(); return; }
      target = event.target.closest('[data-gallery-image]');
      if (target && root.contains(target)) {
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault(); prepareDialog(); setIndex(Number(target.dataset.index));
        if (dialog && dialog.showModal) { dialog.showModal(); updateDialogImage(); dialog.querySelector('[data-gallery-close]').focus(); }
      }
    });
    function keys(event) {
      if (event.key === ' ' && event.target.matches('a[data-gallery-select]')) {
        event.preventDefault(); event.target.click(); return;
      }
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1, event.currentTarget === dialog ? event.target : null);
    }
    stage.addEventListener('keydown', keys);
    if (dialog) {
      dialog.addEventListener('keydown', keys);
      dialog.addEventListener('close', function () { var visible = currentImage(); if (visible) visible.focus(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    }
    stage.addEventListener('touchstart', function (event) { var point = event.changedTouches[0]; touch = { x:point.clientX, y:point.clientY }; }, { passive:true });
    stage.addEventListener('touchend', function (event) { if (!touch) return; var point = event.changedTouches[0], x = point.clientX-touch.x, y = point.clientY-touch.y; touch = null; if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y) * 1.5) move(x < 0 ? 1 : -1); }, { passive:true });
    setIndex(index);
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-vnd-character-gallery]').forEach(initialize); }
  window.VindemiloCharacterGallery = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());

